import React ,{useEffect} from 'react';
import clsx from 'clsx';
import EditInputComponent from '../../EditInputComponent';
import EditLabelComponent from '../../EditLabelComponent';
import EditTextareaComponent from '../../EditTextareaComponent';
import EditButtonComponent from '../../EditButtonComponent';
import EditDropdownComponent from '../../EditDropdownComponent';
import EditRadioComponent from '../../EditRadioComponent';
import SummaryRow from '../../../../DataElements/SummaryRow';
import RowElement from '../../../../DataElements/RowElement';
import DropdownMechanismFixLabel from '../../../../../GeneralComponents/DropdownMechanismFixLabel';

/*
This function returns the react component that is responsible for a row inside the pop up window of an edit form data element. 
*/
const  FormRowComponent = (props) => {
    const{
        index,
        editor,
        componentsInfo,
        setComponentsInfo,
        setAdded,
        added,
        clickedEdit,
        rowsComponentsIds,
        setRowsComponentsIds,
        deleteComps,
        setDeleteComps,
        selectedProject
    } = props;

    const [displayContent, setDisplayContent] = React.useState(false);
    const [infoSummary, setInfoSummary] = React.useState([]);
    const ElementTypes = ['label', 'input', 'textarea','button','dropdown', 'radio'];
    const ElementTypes2 = ['label', 'input', 'textarea','button','dropdown'];
    const [initComponentsInfo, setInitComponentsInfo] = React.useState(false);

    /*
    This useEffect is runned when the edit pop up window is opened or when a component is added or deleted inside the row.
    It initiates and stores inside the componentsInfo var all the available info about the components of the row and this 
    var will be used if we want to generate a block
    */
   
    useEffect(() => {
        const tempInfoSummary = [];
        componentsInfo[index].div.forEach( (insideElement,index3) => {
            
            if(insideElement === 'label'){
                const { label } = componentsInfo[index].info[index3];
                tempInfoSummary.push({'label': label})
            }
            else if(insideElement === 'input'){
                const { placeholder } = componentsInfo[index].info[index3];
                const { text } = componentsInfo[index].info[index3];
                tempInfoSummary.push({'placeholder': placeholder,'type': text})
            }
            else if(insideElement === 'radio'){
                const options = componentsInfo[index].info[index3].labels;
                tempInfoSummary.push({'labels': options})
            }
            else if(insideElement === 'checkbox'){
                const { label } = componentsInfo[index].info[index3];
                const { checked } = componentsInfo[index].info[index3];
                tempInfoSummary.push({'label': label, 'checked': checked});
            }
            else if(insideElement === 'textarea'){
                const { placeholder } = componentsInfo[index].info[index3];
                tempInfoSummary.push({'placeholder': placeholder})
            }
            else if(insideElement === 'button'){
                const { label } = componentsInfo[index].info[index3];
                tempInfoSummary.push({'label': label})
            }
            else if(insideElement === 'dropdown'){
                const { label } = componentsInfo[index].info[index3];
                const { options } = componentsInfo[index].info[index3];

                tempInfoSummary.push({'label': label, 'options': options})
            }

        })
        setInfoSummary(tempInfoSummary);
        setInitComponentsInfo(true);
    },[added])

    /*
    This function deletes the whole row from the pop up window edit form
    */
    const deleteElement = () => {
        const rowId = rowsComponentsIds[index].id;
                
        const tempDeleteComps = [...deleteComps];
        tempDeleteComps.push(rowId);
        setDeleteComps(tempDeleteComps)

        const tempComponentsInfo = [...componentsInfo];
        tempComponentsInfo.splice(index,1);
        setComponentsInfo(tempComponentsInfo);
        
        const tempRowsComponentsIds = [...rowsComponentsIds];
        tempRowsComponentsIds.splice(index,1);
        setRowsComponentsIds(tempRowsComponentsIds);
        
        setAdded(true);
    }

    

    /*
    This function adds a new component to the selected row of the edited form in the ui of pop up window. When it adds the component to
    componentsInfo var then it triggers var added to  render again the correct info in the ui
    */
    const addElement = (option) => {

        const tempComponentsInfo = [...componentsInfo];
        const tempRowsComponentsIds = [...rowsComponentsIds];

        if(option === 'input'){

            tempComponentsInfo[index].div.push('input');
            tempComponentsInfo[index].info.push({placeholder: 'Type here your name', required: false, type: 'text'})
            tempRowsComponentsIds[index].insideIds.push(-1);
        }
        else if(option === 'label'){
            tempComponentsInfo[index].div.push('label');
            tempComponentsInfo[index].info.push({label: 'Name'})
            tempRowsComponentsIds[index].insideIds.push(-1);
        }
        /*
        else if(option === 'checkbox'){
            tempComponentsInfo[index].div.push('checkbox');
            tempComponentsInfo[index].info.push({checked: false})
            tempRowsComponentsIds[index].insideIds.push(-1); 
        }
        */
        else if(option === 'radio'){
            tempComponentsInfo[index].div.push('radio');
            tempComponentsInfo[index].info.push({labels: ['M', 'F'], ids: [-1,-1]});
            tempRowsComponentsIds[index].insideIds.push(-1);
        }
        else if(option === 'button'){
            tempComponentsInfo[index].div.push('button');
            tempComponentsInfo[index].info.push({method: 'GET',label: 'Send', href: '', target_page: ''})
            tempRowsComponentsIds[index].insideIds.push(-1);
        }
        else if(option === 'textarea'){
            tempComponentsInfo[index].div.push('textarea');
            tempComponentsInfo[index].info.push({method: '',label: 'Send', href: '', target_page: ''})
            tempRowsComponentsIds[index].insideIds.push(-1);
        }
        else if(option === 'dropdown'){
            tempComponentsInfo[index].div.push('dropdown');
            tempComponentsInfo[index].info.push({label: 'Dropdown button', options: ['Link1', 'Link2', 'Link3']})
            tempRowsComponentsIds[index].insideIds.push(-1);
        }

        setComponentsInfo(tempComponentsInfo);
        setRowsComponentsIds(tempRowsComponentsIds);
        setAdded(true);
        
    }

    function checkIfRadioExist (){
        let exists = false;

        componentsInfo[index].div.forEach( comp => {
            if(comp === 'radio'){
                exists = true
            }
        })

        return exists;
    }

    return(
        <div className={clsx('spacingTopDiv')}>
            <RowElement
                label={`Row ${index+1}`}
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteElement}
            />
            <div className={clsx('spacingTopDiv', 'spacingLeftDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>
                <SummaryRow
                    infoRow = {infoSummary}
                    componentsRow = {componentsInfo[index].div}
                />
                <div >
                    {componentsInfo[index].div.map( (component,index2) => 

                        {
                            if(component === 'button' && infoSummary[index2] !== undefined){
                                return(
                                    <EditButtonComponent
                                        componentId={rowsComponentsIds[index].insideIds[index2]}
                                        index={index}
                                        index2={index2}
                                        componentsInfo={componentsInfo}
                                        setComponentsInfo={setComponentsInfo}
                                        rowsComponentsIds={rowsComponentsIds}
                                        setRowsComponentsIds={setRowsComponentsIds}
                                        setAdded={setAdded}
                                        editor={editor}
                                        added={added}
                                        clickedEdit={clickedEdit}
                                        infoSummary={infoSummary}
                                        setInfoSummary={setInfoSummary}
                                        initComponentsInfo={initComponentsInfo}
                                        setInitComponentsInfo={setInitComponentsInfo}
                                        deleteComps={deleteComps}
                                        setDeleteComps={setDeleteComps}
                                        selectedProject={selectedProject}
                                        key={`Row${index}ComponentButton`}
                                    />
                                )
                            }
                            if(component === 'input' && infoSummary[index2] !== undefined){
                                return(
                                    <EditInputComponent
                                        componentId={rowsComponentsIds[index].insideIds[index2]}
                                        index={index}
                                        index2={index2}
                                        componentsInfo={componentsInfo}
                                        setComponentsInfo={setComponentsInfo}
                                        rowsComponentsIds={rowsComponentsIds}
                                        setRowsComponentsIds={setRowsComponentsIds}
                                        setAdded={setAdded}
                                        editor={editor}
                                        added={added}
                                        clickedEdit={clickedEdit}
                                        infoSummary={infoSummary}
                                        setInfoSummary={setInfoSummary}
                                        initComponentsInfo={initComponentsInfo}
                                        setInitComponentsInfo={setInitComponentsInfo}
                                        deleteComps={deleteComps}
                                        setDeleteComps={setDeleteComps}
                                        key={`Row${index}ComponentInput`}
                                    />    
                                )
                            }
                            if(  component === 'textarea' && infoSummary[index2] !== undefined){
                                return(
                                    <EditTextareaComponent
                                        componentId={rowsComponentsIds[index].insideIds[index2]}
                                        index={index}
                                        index2={index2}
                                        componentsInfo={componentsInfo}
                                        setComponentsInfo={setComponentsInfo}
                                        rowsComponentsIds={rowsComponentsIds}
                                        setRowsComponentsIds={setRowsComponentsIds}
                                        setAdded={setAdded}
                                        editor={editor}
                                        added={added}
                                        clickedEdit={clickedEdit}
                                        infoSummary={infoSummary}
                                        setInfoSummary={setInfoSummary}
                                        initComponentsInfo={initComponentsInfo}
                                        setInitComponentsInfo={setInitComponentsInfo}
                                        deleteComps={deleteComps}
                                        setDeleteComps={setDeleteComps}
                                        key={`Row${index}ComponentTextarea`}
                                    />  
                                )
                            }
                            if(component === 'radio'){
                                return(
                                    <EditRadioComponent
                                        index={index}
                                        index2={index2}
                                        componentsInfo={componentsInfo}
                                        setComponentsInfo={setComponentsInfo}
                                        rowsComponentsIds={rowsComponentsIds}
                                        setRowsComponentsIds={setRowsComponentsIds}
                                        setAdded={setAdded}
                                        clickedEdit={clickedEdit}
                                        initComponentsInfo={initComponentsInfo}
                                        deleteComps={deleteComps}
                                        setDeleteComps={setDeleteComps}
                                        editor={editor}
                                        infoSummary={infoSummary}
                                        setInfoSummary={setInfoSummary}
                                        key={`Row${index}ComponentRadio`}
                                    />     
                                )
                            }
                            if(component === 'label' && infoSummary[index2] !== undefined){
                                return(
                                    <EditLabelComponent
                                        componentId={rowsComponentsIds[index].insideIds[index2]}
                                        index={index}
                                        index2={index2}
                                        componentsInfo={componentsInfo}
                                        setComponentsInfo={setComponentsInfo}
                                        rowsComponentsIds={rowsComponentsIds}
                                        setRowsComponentsIds={setRowsComponentsIds}
                                        editor={editor}
                                        added={added}
                                        clickedEdit={clickedEdit}
                                        infoSummary={infoSummary}
                                        setInfoSummary={setInfoSummary}
                                        initComponentsInfo={initComponentsInfo}
                                        deleteComps={deleteComps}
                                        setDeleteComps={setDeleteComps}
                                        key={`Row${index}ComponentLabel`}
                                    />
                                )
                            }
                            if(component === 'dropdown'){
                                return(
                                    <EditDropdownComponent
                                        componentId={rowsComponentsIds[index].insideIds[index2]}
                                        index={index}
                                        index2={index2}
                                        componentsInfo={componentsInfo}
                                        setComponentsInfo={setComponentsInfo}
                                        rowsComponentsIds={rowsComponentsIds}
                                        setRowsComponentsIds={setRowsComponentsIds}
                                        setAdded={setAdded}
                                        editor={editor}
                                        added={added}
                                        clickedEdit={clickedEdit}
                                        infoSummary={infoSummary}
                                        setInfoSummary={setInfoSummary}
                                        initComponentsInfo={initComponentsInfo}
                                        deleteComps={deleteComps}
                                        setDeleteComps={setDeleteComps}
                                        setInitComponentsInfo={setInitComponentsInfo}  
                                        key={`Row${index}ComponentDropdownComp`}                                                                              
                                    />
                                )
                            }
                            return '';
                        }                       
                    )}
                </div>
                <DropdownMechanismFixLabel 
                    ElementTypes = {checkIfRadioExist() === true ? ElementTypes2: ElementTypes }
                    addElement = {addElement}
                    label = ' Add new element'
                />
            </div>
            
          
        </div>
    )
}

export default  FormRowComponent;